import { takeEvery, call, fork, select } from 'redux-saga/effects'
import featureToggles from 'shared/featureToggles'
import { indicateProgress } from 'api'
import { userSelector, businessAccountSelector } from 'auth/selectors'
import { getCurrentUserSaga } from 'auth/sagas'
import { sendGTAGEvent } from 'analytics/utils'
import { CREATE_VEHICLE, REMOVE_VEHICLE } from 'dashboard-vehicles/constants'
import * as grsApi from 'dashboard-vehicles/grsApi'
import * as nAmApi from 'dashboard-vehicles/nAmApi'

export function* createVehicleSaga() {
    yield takeEvery(
        CREATE_VEHICLE,
        function* ({ tag, make, model, color, country, state, isRentalCar, rentalExpiryDate, onSuccess }) {
            try {
                yield indicateProgress(['createVehicle'], function* () {
                    const { token, accountKey } = yield select(userSelector)
                    const isBusinessAccount = yield select(businessAccountSelector)

                    if (featureToggles.newAuthFlow) {
                        yield call(
                            nAmApi.createVehicle,
                            accountKey,
                            token,
                            tag,
                            make,
                            model,
                            color,
                            country,
                            state,
                            isBusinessAccount
                        )
                    } else {
                        yield call(grsApi.createVehicle, token, tag, make, model, color, isRentalCar, rentalExpiryDate)
                    }

                    onSuccess && onSuccess()

                    sendGTAGEvent('add_vehicle', {})
                    yield getCurrentUserSaga()
                })
            } catch (e) {}
        }
    )
}

export function* removeVehicleSaga() {
    yield takeEvery(REMOVE_VEHICLE, function* ({ vehicle }) {
        try {
            yield indicateProgress(['removeVehicle', `removeVehicle-${vehicle.id}`], function* () {
                const isBusinessAccount = yield select(businessAccountSelector)
                if (featureToggles.newAuthFlow) {
                    const { token, accountKey } = yield select(userSelector)
                    yield call(nAmApi.removeVehicle, accountKey, token, vehicle.id, !isBusinessAccount)
                } else {
                    yield call(grsApi.removeVehicle, vehicle)
                }

                yield getCurrentUserSaga()
            })
        } catch (e) {}
    })
}

export function* rootSaga() {
    yield fork(createVehicleSaga)
    yield fork(removeVehicleSaga)
}
